import { render } from "./IconCancel.vue?vue&type=template&id=046ecac2"
import script from "./IconCancel.vue?vue&type=script&lang=js"
export * from "./IconCancel.vue?vue&type=script&lang=js"
script.render = render

export default script